module.exports = __webpack_public_path__ + "img/14.ba57cce1.webp";